import { FC } from 'react'
import { Skeleton } from '@mui/material'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo'
import { useWritingScores } from '../../../helpers/hooks/useWritingScores'
import { ScoringState } from '../../../storage'
import { useSnapshot } from 'valtio'
import { IconRow, InfoIcon, ScoreColumn, ScoreLabel, ScorePanelContainer, SubScoreLabel } from './styles'

const getSubScoreName = (name: string) =>
  name === 'Language Use' ? 'Language Use and Conventions' : name

const WritingScorePanel: FC = () => {
  const { loading, score, scorePending, subScores } = useWritingScores()
  const { groupMode, groupTestScoring } = useSnapshot(ScoringState)
  const scoreSummary = groupTestScoring?.scoreSummary
  const scoreLabel = groupMode ? 'Average Score' : 'Score'
  const subScoreLabel = groupMode ? 'Average' : ''

  if (groupMode && !scoreSummary) {
    return null
  }

  if (loading) {
    return (
      <ScorePanelContainer data-automation-id="writing-score-panel">
        <Skeleton data-automation-id="writing-score-panel-skeleton" variant="rectangular" height={120} />
      </ScorePanelContainer>
    )
  }

  if (score === null) {
    if (scorePending) {
      return (
        <ScorePanelContainer data-automation-id="writing-score-panel">
          <IconRow>
            <InfoIcon icon={faCircleInfo} />
            <ScoreColumn>
              <ScoreLabel variant="body1">Score: Pending</ScoreLabel>
            </ScoreColumn>
          </IconRow>
        </ScorePanelContainer>
      )
    }

    if (groupMode) {
      return (
        <ScorePanelContainer data-automation-id="writing-score-panel">
          <IconRow>
            <InfoIcon icon={faCircleInfo} />
            <ScoreColumn>
              <ScoreLabel variant="body1">Average Score: Not available</ScoreLabel>
            </ScoreColumn>
          </IconRow>
        </ScorePanelContainer>
      )
    }

    return null
  }

  if (subScores === null || subScores === undefined) {
    return null
  }

  return (
    <ScorePanelContainer data-automation-id="writing-score-panel">
      <IconRow>
        <InfoIcon icon={faCircleInfo} />
        <ScoreColumn>
          <ScoreLabel variant="body1">{`${scoreLabel}: ${score}`}</ScoreLabel>
          {groupMode && scoreSummary?.studentCount ? (
            <SubScoreLabel variant="body2">{`Students: ${scoreSummary.studentCount}`}</SubScoreLabel>
          ) : null}
          {subScores?.map(sub => (
            <SubScoreLabel key={sub.name} variant="body2">
              {subScoreLabel
                ? `${getSubScoreName(sub.name)} ${subScoreLabel}: ${sub.scale}`
                : `${getSubScoreName(sub.name)}: ${sub.scale}`}
            </SubScoreLabel>
          ))}
        </ScoreColumn>
      </IconRow>
    </ScorePanelContainer>
  )
}

export default WritingScorePanel
